import dispatcher from "../dispatcher";
import { tankConstant } from "../constants/constants";
import rq from "../components/utility/rq.js";

export function createTank(tank) {
    rq.post("/api/v1/tanks", tank).then((data) => {
        tank.tankId = data[0].lastId;
        dispatcher.dispatch({ type: tankConstant.TANK_CREATED, tank, msg: `Tank ${tank.tankName} created successfully.` });
    }).catch((data) => {
        dispatcher.dispatch({ type: tankConstant.TANK_CREATION_FAILED, msg: data.msg || `creating tank ${tank.tankName} failed ! ${data.responseText}` });
    });
}

export function fetchAllTanks() {
    rq.getJsonData("/api/v1/tanks").then((data) => {
        dispatcher.dispatch({ type: tankConstant.FETCHED_ALL_TANKS, data, msg: `all tanks fetched successfully.` });
    }).catch((data) => {
        dispatcher.dispatch({ type: tankConstant.TANK_FETCH_FAILED, msg: `Fetching tanks failed ! ${data.responseText}` });
    });
}
export function fetchAllDipTable() {
    rq.getJsonData("/api/v1/dip-table").then((data) => {
        //console.log("inside action dip ", data);
        dispatcher.dispatch({ type: tankConstant.FETCHED_ALL_DIP_TABLE, data, msg: `all dip table fetched successfully.` });
    }).catch((data) => {
        dispatcher.dispatch({ type: tankConstant.DIP_TABLE_FETCH_FAILED, msg: `Fetching dip table failed !` });
    });
}


// WEBPACK FOOTER //
// ./src/jsx/actions/tank-action.jsx